import React from 'react'
import injectSheet from 'react-jss'
import styles from './entry-skeleton.styles'
import { TableRow, Cell } from 'pobble-components/dist/table'
import Bone from 'pobble-components/dist/bone'

const EntrySkeleton = ({ classes, titleWidth = 80 }) => (
  <TableRow>
    <Cell center>
      <Bone className={classes.checkbox} />
    </Cell>
    <Cell>
      <Bone className={classes.date} />
    </Cell>
    <Cell className={classes.thumbnailCell}>
      <Bone className={classes.thumbnail} />
    </Cell>
    <Cell>
      <Bone style={{ width: `${titleWidth}%` }} />
    </Cell>
    <Cell center>
      <Bone className={classes.sta} />
    </Cell>
    <Cell center>
      <Bone className={classes.ageGroup} />
    </Cell>
    <Cell center>
      <Bone className={classes.published} />
    </Cell>
    <Cell right>
      <Bone className={classes.contextMenu} />
    </Cell>
  </TableRow>
)

export default injectSheet(styles)(EntrySkeleton)
